"use strict";

var _classCallCheck = require("/Users/zacharialutz/projects/thinkful_EI/capstone-3/Group5-Capstone3-Client/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/zacharialutz/projects/thinkful_EI/capstone-3/Group5-Capstone3-Client/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/zacharialutz/projects/thinkful_EI/capstone-3/Group5-Capstone3-Client/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/zacharialutz/projects/thinkful_EI/capstone-3/Group5-Capstone3-Client/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/zacharialutz/projects/thinkful_EI/capstone-3/Group5-Capstone3-Client/node_modules/@babel/runtime/helpers/inherits");

var CharacterDataImpl = require("./CharacterData-impl").implementation;

var _require = require("../helpers/internal-constants"),
    domSymbolTree = _require.domSymbolTree;

var DOMException = require("domexception");

var NODE_TYPE = require("../node-type");

var TextImpl =
/*#__PURE__*/
function (_CharacterDataImpl) {
  _inherits(TextImpl, _CharacterDataImpl);

  function TextImpl(args, privateData) {
    var _this;

    _classCallCheck(this, TextImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TextImpl).call(this, args, privateData));
    _this.nodeType = NODE_TYPE.TEXT_NODE;
    return _this;
  }

  _createClass(TextImpl, [{
    key: "splitText",
    value: function splitText(offset) {
      offset >>>= 0;
      var length = this.length;

      if (offset > length) {
        throw new DOMException("The index is not in the allowed range.", "IndexSizeError");
      }

      var count = length - offset;
      var newData = this.substringData(offset, count);

      var newNode = this._ownerDocument.createTextNode(newData);

      var parent = domSymbolTree.parent(this);

      if (parent !== null) {
        parent.insertBefore(newNode, this.nextSibling);
      }

      this.replaceData(offset, count, "");
      return newNode; // TODO: range stuff
    }
  }, {
    key: "wholeText",
    get: function get() {
      var wholeText = this.textContent;
      var next;
      var current = this;

      while ((next = domSymbolTree.previousSibling(current)) && next.nodeType === NODE_TYPE.TEXT_NODE) {
        wholeText = next.textContent + wholeText;
        current = next;
      }

      current = this;

      while ((next = domSymbolTree.nextSibling(current)) && next.nodeType === NODE_TYPE.TEXT_NODE) {
        wholeText += next.textContent;
        current = next;
      }

      return wholeText;
    }
  }]);

  return TextImpl;
}(CharacterDataImpl);

module.exports = {
  implementation: TextImpl
};